import { PollOverview } from 'api/api.types';
import { isPoll } from './poll';

export const ISSUE_FILTER_TYPES = {
  poll: 'poll',
  localElection: 'localElection',
  grossRat: 'grossRat',
  councilOfStates: 'councilOfStates',
  nationalCouncil: 'nationalCouncil',
  governmentCouncil: 'governmentCouncil',
  other: 'other',
} as const;

const getIssueType = (issue: PollOverview) => {
  if (isPoll(issue.type)) {
    // Abstimmungen
    return ISSUE_FILTER_TYPES.poll;
  }

  if (issue.type === 'election_proportional_apportionment') {
    // Nationalrat
    return ISSUE_FILTER_TYPES.nationalCouncil;
  }

  if (issue.type === 'election_majority_system') {
    if (issue.scope === 'cantonal') {
      // Regierungsrat oder Ständerat
      return ISSUE_FILTER_TYPES.governmentCouncil;
    }
    // Bezirk/Kreiswahl
    return ISSUE_FILTER_TYPES.localElection;
  }

  if (issue.type === 'election_biproportional_apportionment') {
    // Grossratswahl
    return ISSUE_FILTER_TYPES.grossRat;
  }

  return ISSUE_FILTER_TYPES.other;
};

export default getIssueType;
